module.exports = __webpack_public_path__ + "static/img/core-bg-05.86df3b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/core-bg-05.png
// module id = MHwk
// module chunks = 1